import React, { useState, forwardRef, useImperativeHandle } from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { DateInput } from '../../Components';

function getHojeFormatado() {
  const hoje = new Date();
  const ano = hoje.getFullYear();
  const mes = String(hoje.getMonth() + 1).padStart(2, '0');
  const dia = String(hoje.getDate()).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
}

const DialogoEditarDataAgendamento = forwardRef(({ handleSalvar }, ref) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [data, setData] = useState('');

  const hojeFormatado = getHojeFormatado();
  const dataNoPassado = !!data && data < hojeFormatado;

  useImperativeHandle(ref, () => ({
    handleOpen(idParam, dataAgendamentoAtual) {
      setId(idParam);
      setData(
        dataAgendamentoAtual ? dataAgendamentoAtual.substring(0, 10) : '',
      );
      setOpen(true);
    },
  }));

  function handleClose() {
    setOpen(false);
  }

  function handleConfirmar() {
    if (!data || dataNoPassado) return;
    handleSalvar(id, data);
    setOpen(false);
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>Editar Próxima Data de Compra</DialogTitle>
      <DialogContent>
        <Box mt="0.5em">
          <DateInput
            name="data_agendamento"
            label="Próxima Data de Compra"
            value={data}
            onChange={(value) => setData(value.target.value)}
            inputProps={{ min: hojeFormatado }}
            error={dataNoPassado}
            helperText={
              dataNoPassado ? 'A data não pode ser anterior a hoje' : ''
            }
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button
          onClick={handleConfirmar}
          color="primary"
          variant="contained"
          disabled={!data || dataNoPassado}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default DialogoEditarDataAgendamento;
